import { SchemaScript } from "@tokenterminal/core/ui/seo/SchemaScript"
import { SITE_URL } from "@tokenterminal/core/ui/seo/SiteSchemas"
import type { Author } from "@/components/resources/data/posts.types"
import { BASE_BLOG_PATH } from "@/constants/urls"

/** Absolute URL of a local image. External and empty values pass through. */
export const absoluteUrl = (url: string) => (url.startsWith("/") ? `${SITE_URL}${url}` : url)

/** The author as a Person or Organization, for the post and author page schemas */
export const authorEntity = ({ slug, nickname, title, image, socials, schemaType }: Author) => ({
  "@type": schemaType,
  name: nickname,
  url: `${SITE_URL}${BASE_BLOG_PATH}/author/${slug}`,
  // Undefined keys are left out of the JSON
  image: image ? absoluteUrl(image) : undefined,
  jobTitle: schemaType === "Person" ? title : undefined,
  sameAs: socials.map(({ url }) => url),
})

/** ProfilePage JSON-LD for an author page */
export const AuthorSchema = ({ author }: { author: Author }) => (
  <SchemaScript
    id="author"
    schema={{
      "@context": "https://schema.org",
      "@type": "ProfilePage",
      mainEntity: authorEntity(author),
    }}
  />
)
